import React from 'react'
import Header from '../../components/Header'
import "../../assets/css/Offer.css"
import Footer from '../../components/Footer'

function Offer() {
  return (
    <>
    <Header />
        <div className="container-fluid">
    <div className="row py-4">
        <div className="col-md-12 pl-5">
            <h4 className="blue">All Conversation</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                et dolore magna aliqua. .
            </p>
        </div>
    </div>
</div>

<div className="card rare-wind-gradient chat-room">
    <div className="card-body">
        {/* <!-- Grid row --> */}
        <div className="row px-lg-2 px-2">
            {/* <!-- Grid column --> */}
            <div className="col-md-3 col-xl-3 px-0">
                <div className="white z-depth-1 px-2 pt-3 pb-0 members-panel-1 scrollbar-light-blue">
                    <ul className="list-unstyled friend-list border-bottom">
                        <li className="active grey lighten-3 p-2">
                            <a href="#" className="d-flex justify-content-between">
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-8.jpg" whidth="100"
                                    height="100" alt="avatar"
                                    className="avatar rounded-circle d-flex align-self-center mr-2 z-depth-1"
                                />
                                <div className="text-small pt-3">
                                    <strong>John Doe</strong>
                                    <p className="last-message text-muted "><span className="orange">Senior Care</span><br />
                                        <span>Manchester, England</span>
                                    </p>
                                </div>
                                <div className="chat-footer pt-3">
                                    <p className="text-smaller text-muted mb-0"><i className="fa fa-star"></i> 4.5</p>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <ul className="list-unstyled friend-list">
                        <li className="active grey lighten-3 p-2">
                            <a href="#" className="d-flex justify-content-between">
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-8.jpg" alt="avatar"
                                    className="avatar rounded-circle d-flex align-self-center mr-2 z-depth-1" />
                                <div className="text-small pt-3">
                                    <strong>John Doe</strong>
                                    <p className="last-message text-muted">Hello, Are you there?</p>
                                </div>
                                <div className="chat-footer pt-3">
                                    <p className="text-smaller text-muted mb-0">Just now</p>
                                    <span className="badge badge-danger float-right">1</span>
                                </div>
                            </a>
                        </li>
                        <li className="p-2">
                            <a href="#" className="d-flex justify-content-between">
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-1.jpg" alt="avatar"
                                    className="avatar rounded-circle d-flex align-self-center mr-2 z-depth-1" />
                                <div className="text-small pt-3">
                                    <strong>Danny Smith</strong>
                                    <p className="last-message text-muted">Lorem ipsum dolor sit.</p>
                                </div>
                                <div className="chat-footer pt-3">
                                    <p className="text-smaller text-muted mb-0">5 min ago</p>
                                    <span className="text-muted float-right"><i className="fas fa-mail-reply"
                                            aria-hidden="true"></i></span>
                                </div>
                            </a>
                        </li>
                        <li className="p-2">
                            <a href="#" className="d-flex justify-content-between">
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-2.jpg" alt="avatar"
                                    className="avatar rounded-circle d-flex align-self-center mr-2 z-depth-1" />
                                <div className="text-small pt-3">
                                    <strong>Alex Steward</strong>
                                    <p className="last-message text-muted">Lorem ipsum dolor sit.</p>
                                </div>
                                <div className="chat-footer pt-3">
                                    <p className="text-smaller text-muted mb-0">Yesterday</p>
                                    <span className="text-muted float-right"><i className="fas fa-mail-reply"
                                            aria-hidden="true"></i></span>
                                </div>
                            </a>
                        </li>
                        <li className="p-2">
                            <a href="#" className="d-flex justify-content-between">
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-3.jpg" alt="avatar"
                                    className="avatar rounded-circle d-flex align-self-center mr-2 z-depth-1" />
                                <div className="text-small pt-3">
                                    <strong>Ashley Olsen</strong>
                                    <p className="last-message text-muted">Lorem ipsum dolor sit.</p>
                                </div>
                                <div className="chat-footer pt-3">
                                    <p className="text-smaller text-muted mb-0">Yesterday</p>
                                    <span className="text-muted float-right"><i className="fas fa-mail-reply"
                                            aria-hidden="true"></i></span>
                                </div>
                            </a>
                        </li>
                        <li className="p-2">
                            <a href="#" className="d-flex justify-content-between">
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-4.jpg" alt="avatar"
                                    className="avatar rounded-circle d-flex align-self-center mr-2 z-depth-1" />
                                <div className="text-small pt-3">
                                    <strong>Kate Moss</strong>
                                    <p className="last-message text-muted">Lorem ipsum dolor sit.</p>
                                </div>
                                <div className="chat-footer pt-3">
                                    <p className="text-smaller text-muted mb-0">Yesterday</p>
                                    <span className="text-muted float-right"><i className="fas fa-mail-reply"
                                            aria-hidden="true"></i></span>
                                </div>
                            </a>
                        </li>
                        <li className="p-2">
                            <a href="#" className="d-flex justify-content-between">
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-5.jpg" alt="avatar"
                                    className="avatar rounded-circle d-flex align-self-center mr-2 z-depth-1" />
                                <div className="text-small">
                                    <strong>Lara Croft</strong>
                                    <p className="last-message text-muted">Lorem ipsum dolor sit.</p>
                                </div>
                                <div className="chat-footer">
                                    <p className="text-smaller text-muted mb-0">Yesterday</p>
                                    <span className="text-muted float-right"><i className="fas fa-mail-reply"
                                            aria-hidden="true"></i></span>
                                </div>
                            </a>
                        </li>
                        <li className="p-2">
                            <a href="#" className="d-flex justify-content-between">
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-6.jpg" alt="avatar"
                                    className="avatar rounded-circle d-flex align-self-center mr-2 z-depth-1" />
                                <div className="text-small">
                                    <strong>Brad Pitt</strong>
                                    <p className="last-message text-muted">Lorem ipsum dolor sit.</p>
                                </div>
                                <div className="chat-footer">
                                    <p className="text-smaller text-muted mb-0">5 min ago</p>
                                    <span className="text-muted float-right"><i className="fas fa-check"
                                            aria-hidden="true"></i></span>
                                </div>
                            </a>
                        </li>
                        <li className="p-2">
                            <a href="#" className="d-flex justify-content-between">
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/img(3).jpg.jpg" alt="avatar"
                                    className="avatar rounded-circle d-flex align-self-center mr-2 z-depth-1" />
                                <div className="text-small">
                                    <strong>Ken Ditto</strong>
                                    <p className="last-message text-muted">Lorem ipsum dolor sit.</p>
                                </div>
                                <div className="chat-footer">
                                    <p className="text-smaller text-muted mb-0">Yesterday</p>
                                    <span className="text-muted float-right"><i className="fas fa-mail-reply"
                                            aria-hidden="true"></i></span>
                                </div>
                            </a>
                        </li>
                        <li className="p-2">
                            <a href="#" className="d-flex justify-content-between">
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/img(2).jpg.jpg" alt="avatar"
                                    className="avatar rounded-circle d-flex align-self-center mr-2 z-depth-1" />
                                <div className="text-small">
                                    <strong>Marta Wozniak</strong>
                                    <p className="last-message text-muted">Lorem ipsum dolor sit.</p>
                                </div>
                                <div className="chat-footer">
                                    <p className="text-smaller text-muted mb-0">Yesterday</p>
                                    <span className="text-muted float-right"><i className="fas fa-mail-reply"
                                            aria-hidden="true"></i></span>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>

            </div>
            {/* <!-- Grid column --> */}

            {/* <!-- Grid column --> */}
            <div className="col-md-9 col-xl-9 pl-md-3 px-lg-auto px-0">

                <div className="chat-message">

                    <ul className="list-unstyled chat-1 scrollbar-light-blue">
                        <li className="d-flex  justify-content-left mb-4">
                            <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-6.jpg" alt="avatar"
                                className="avatar rounded-circle mr-2 ml-lg-3 ml-0 z-depth-1" />
                            <div className="chat-body white p-3 ml-2 z-depth-1">
                                <p className="mb-0">
                                    Lorem ipsum dolor sit amet,
                                </p>
                                <div className="header">
                                    <strong className="primary-font">Brad Pitt</strong>
                                    <small className="pull-right text-muted"><i className="far fa-clock"></i> 12 mins
                                        ago</small>
                                </div>
                            </div>
                        </li>
                        <li className="d-flex justify-content-end mb-4">
                            <div className="chat-body white p-3 z-depth-1">

                                <p className="mb-0 text-white blue-back">
                                    Sed ut perspiciatis unde omnis iste natus error
                                </p>
                                <div className="header ">
                                    <strong className="primary-font">Lara Croft</strong>
                                    <small className="pull-right text-muted"><i className="far fa-clock"></i> 13 mins
                                        ago</small>
                                </div>
                            </div>
                            <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-5.jpg" alt="avatar"
                                className="avatar rounded-circle mr-0 ml-3 z-depth-1" />
                        </li>
                        <li className="d-flex  justify-content-left mb-4">
                            <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-6.jpg" alt="avatar"
                                className="avatar rounded-circle mr-2 ml-lg-3 ml-0 z-depth-1" />
                            <div className="chat-body white p-3 ml-2 z-depth-1">
                                <p className="mb-0">
                                    Lorem ipsum dolor sit amet,
                                </p>
                                <div className="header">
                                    <strong className="primary-font">Brad Pitt</strong>
                                    <small className="pull-right text-muted"><i className="far fa-clock"></i> 12 mins
                                        ago</small>
                                </div>
                            </div>
                        </li>
                        <li className="d-flex justify-content-end mb-4">
                            <div className="chat-body white p-3 z-depth-1">

                                <p className="mb-0 text-white blue-back">
                                    Sed ut perspiciatis unde omnis iste natus error
                                </p>
                                <div className="header ">
                                    <strong className="primary-font">Lara Croft</strong>
                                    <small className="pull-right text-muted"><i className="far fa-clock"></i> 13 mins
                                        ago</small>
                                </div>
                            </div>
                            <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-5.jpg" alt="avatar"
                                className="avatar rounded-circle mr-0 ml-3 z-depth-1" />
                        </li>
                        <li className="d-flex  justify-content-left mb-4">
                            <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-6.jpg" alt="avatar"
                                className="avatar rounded-circle mr-2 ml-lg-3 ml-0 z-depth-1" />
                            <div className="chat-body white p-3 ml-2 z-depth-1">
                                <p className="mb-0">
                                    Lorem ipsum dolor sit amet,
                                </p>
                                <div className="header">
                                    <strong className="primary-font">Brad Pitt</strong>
                                    <small className="pull-right text-muted"><i className="far fa-clock"></i> 12 mins
                                        ago</small>
                                </div>
                            </div>
                        </li>
                        <li className="d-flex justify-content-end mb-4">
                            <div className="chat-body white p-3 z-depth-1">
                                <p className="mb-0 text-white blue-back">
                                    Sed ut perspiciatis unde omnis iste natus error
                                </p>
                                <div className="header ">
                                    <strong className="primary-font">Lara Croft</strong>
                                    <small className="pull-right text-muted"><i className="far fa-clock"></i> 13 mins
                                        ago</small>
                                </div>
                            </div>
                            <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-5.jpg" alt="avatar"
                                className="avatar rounded-circle mr-0 ml-3 z-depth-1" />
                        </li>
                    </ul>



                    <div className="container offer">
                        <div className="row panel-r align-middle align-items-center">
                            <div className="col-md-5">
                                <h5 className="blue">[Subcategory] Service Required</h5>
                            </div>
                            <div className="col-md-3 py-1">
                                <span><i className="fa fa-dollar"></i> <b>$100</b> (2 Hours | 2 Days) </span>
                            </div>
                            <div className="col-md-2 py-1">
                                <span><i className="fa fa-calendar"></i> 28 Aug 2021</span>
                            </div>
                            <div className="col-md-2 py-1">
                                <span><i className="fa fa-clock-o"></i> 05 :30 PM </span>
                            </div>
                            <div className="py-2 pl-3 pr-3">
                                <p> Description will come here. Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                                    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                                    veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                                    consequat. Duis aute irure dolor in reprehenderit in voluptate
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-7">
                                <p className="p-13"> <i className="fa fa-map-marker orange"></i> 10515 Fox Ave Fairdale,
                                    Kentucky(KY), 40118 TX | USA <span className="p-13 pl-5"><a href="#">View onMap</a></span></p>
                            </div>
                            <div className="col-md-5 justify-content-right">
                                <p className="justify-content-right text-right"> 
                                    <span><a href="#" className="orange">Reject</a></span> <span><a href="#" className="blue pl-5">Accept</a></span></p>
                            </div>
                        </div>


                    </div>

                    <div className="white">
                        <div className="d-flex justify-content-start">
                            <div className="form-group basic-textarea col-md-9 col-xs-12 col-sm-12">
                                <textarea className="form-control pl-2 my-0" id="exampleFormControlTextarea2" rows="3"
                                    placeholder="Type your message here..."></textarea>
                            </div>


                            <div className="justify-content-end col-md-3 col-xs-12 col-sm-12">
                                <button type="button"
                                    className="btn btn-secondary btn-rounded btn-sm waves-effect waves-dark float-right">Submit
                                    Hiring Request</button>
                            </div>
                        </div>
                    </div>

                </div>
                {/* <!-- Grid column --> */}

            </div>
            {/* <!-- Grid row --> */}

        </div>
    </div>
    </div>
    <Footer />
    </>
  )
}

export default Offer